import Vue from 'vue';
import { STORE } from '@/core/store/core.store';
import { WidgetTeacherCourse } from '@/homework/models/widget-teacher-course.model';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Status } from '@/models/status.model';

@Component({
  name: 'ed-homework-widget-course',
  components: {
    EdHomeworkWidgetPerson: () => import(/* EdHomeworkWidgetPerson */ '../ed-homework-widget-person/ed-homework-widget-person.vue') 
  }
})
export default class EdHomeworkWidgetCourse extends Vue {

  @Prop() readonly widgetCourse : WidgetTeacherCourse;
  
  public personsStatus: Status = new Status();

  get title() {
    return this.widgetCourse.title;
  }

  get opened() {
    let courseOpened: WidgetTeacherCourse = this.$store.state.HomeworksStore.teacherWidgetHomeworks.courseOpened;
    return courseOpened ? (this.widgetCourse.classId == courseOpened.classId && this.widgetCourse.id == courseOpened.id) : false;
  }

  get persons() {
    return this.widgetCourse.persons.content;
  }

  get hasMorePersons() {
    return this.widgetCourse.persons.more;
  }

  get personsListContainer() {
    if(this.opened) {
      this.scrollToCourse();
      return {
        height:'auto',
        maxHeight: this.widgetCourse.maxHeight <= 0 ? '350px' : `${this.widgetCourse.maxHeight}px`
      };
    } else {
      return { maxHeight: 0 };
    }
  }

  scrollToCourse() {
    setTimeout(() => {
      let element: any = this.$el
      let maxHeightPersonList = this.widgetCourse.maxHeight;
      let scrollTopPosition = element.offsetTop;
      let heightInTheContainer = (maxHeightPersonList + scrollTopPosition);
      if(heightInTheContainer > this.$parent.$el.clientHeight) {
        this.$parent.$el.scrollTo({top: scrollTopPosition})
      }
    }, 110);
  }
  
  toggleCourse() {
    this.$store.commit(STORE.HOMEWORKS.MUTATIONS.OPEN_WIDGET_TEACHER_COURSE, this.widgetCourse);
  }

  async getMorePersons() {
    try {
      this.personsStatus.setLoading();
      await this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.GET_STUDENTS_WITH_HOMEWORKS_FROM_COURSE, this.widgetCourse);
      this.personsStatus.setLoad();
      this.setContainerHeight();
    } catch(err) {
      this.personsStatus.setError();
    }
  }

  setContainerHeight() {
    let personContainer: any = this.$refs.personContainer;
    let maxHeightContainer = (this.$parent.$el.clientHeight - 70);
    let maxHeightPersonList = (personContainer.scrollHeight + 95);
    if (this.$parent.$el.clientHeight == 0) this.widgetCourse.maxHeight = 350;
    else this.widgetCourse.maxHeight = maxHeightPersonList > maxHeightContainer ? maxHeightContainer : maxHeightPersonList;
    this.$store.commit(STORE.HOMEWORKS.MUTATIONS.UPDATE_WIDGET_TEACHER_COURSE, this.widgetCourse);
  }

  mounted() {
    this.$nextTick(() => {
      setTimeout(this.setContainerHeight, 500);
    });
  }

}
